import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		violationList: [],
		ifShowViolationList: false,
		searchSuccess:false,
		orderNumber: '',
		handFill: {
			nick: '',
			phone: '',
			nickCarNo: '',
			date: '',
			ticketUrl: '',
			price: '',
			ownFree: 0,
			lateFree: 0,
			showForm2: false,
			showForm1: false,
			showNotice: true,
			drive_no: ''
		},
		ticketPay: {
			driveUrl: '',
			travelUrl: '',
			JSZTravelUrl: '',
			JSZDriveUrl: ''
		},
		selectVioSearch: {

		},

		illegal:{},
	},
	mutations: {
		SET_ILLEGAL (state, illegal) {
			window.localStorage.setItem('illegal', JSON.stringify(illegal))
			state.illegal = illegal
		}
	},
	actions: {
		
	}
});

export default store
